module.exports = __webpack_public_path__ + "img/IconWeb.9015d8f7.png";